import { Navigate } from "react-router";
import { useMe } from "./useMe.ts";

/** Route guard for `/workbench` — non-admins bounce to Settings. */
export function AdminGate({ children }: { children: React.ReactNode }) {
  const me = useMe();

  if (me.isPending) {
    return (
      <div className="flex h-full items-center justify-center bg-bg text-sm text-muted">
        Checking access…
      </div>
    );
  }

  if (me.isError || !me.data?.user.is_admin) {
    return <Navigate to="/settings" replace />;
  }

  return children;
}
